export default __webpack_public_path__ + "static/media/training-illustration7.b8ae13e6.png";